import request from '../request';

/**
 * Fetch unseen mentions from the API.
 * @param {string|null} clientId - Optional client ID.
 * @returns {Promise<Object>} - A Promise that resolves to the API response data.
 * @throws {Error} - If the API request fails, an Error is thrown.
 */
export const getUnseenMentions = async (clientId = null) => {
    try {
        const endpoint = clientId ? `/chat/conversations/mentions/${clientId}` : `/chat/conversations/mentions`;
        const { data, status } = await request('GET', endpoint);
        return { data, status };
    } catch (error) {
        throw new Error(`Failed to get mentions: ${error.message}`);
    }
};

export default getUnseenMentions;
